const maxLength = 150;

export const withElipsis = (body) => `${body?.substring(0, maxLength)}${body?.length > maxLength ? '...' : ''}`; 
